import { PageContext } from 'pages/Quizzes/PageProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon, TextInput } from 'shell/components';

export const ImportButton = () => {
    const { canManageQuizzes, onClickImport } = useContext(PageContext);
    const { t } = useTranslation('quiz');

    return (
        <Button
            disabled={!canManageQuizzes}
            startIcon={<Icon kind={'download'} />}
            sx={{ flexShrink: 0 }}
            tooltip={
                !canManageQuizzes
                    ? { component: t('instructor-only-import', 'Only instructors can import quizzes.'), maxWidth: 250 }
                    : undefined
            }
            onClick={onClickImport}
        >
            {t('common:controls.import', 'Import')}
        </Button>
    );
};

export const QuizFilters = ({ compact = false }) => {
    const { filters, setFilters, filterCount } = useContext(PageContext);
    const { t } = useTranslation('quiz');

    return (
        <>
            <Button
                aria-label={t('common:controls.sort-filter', 'Sort & Filter')}
                color={'neutral'}
                startIcon={<Icon kind={'filter'} />}
                sx={{ flexShrink: 0 }}
                variant={'secondary'}
                onClick={() => setFilters((current) => ({ ...current, open: true }))}
            >
                {!compact && `${t('common:controls.sort-filter', 'Sort & Filter')} `}({filterCount})
            </Button>
            <TextInput
                aria-label={t('search-label', 'Search quizzes')}
                endIcon={<Icon kind={'search'} />}
                placeholder={t('common:controls.search', 'Search')}
                sx={{ flex: compact ? 1 : undefined, minWidth: 0, width: compact ? undefined : 216 }}
                value={filters.search}
                onChange={(event) => setFilters((current) => ({ ...current, search: event.target.value }))}
            />
        </>
    );
};
